import type {ImgHTMLAttributes} from 'react';
import {STANFORD_LOGO_ASSET_SRC} from 'branding/stanfordLogoSrc';

/** Props for {@link StanfordLogo}. Every standard `<img>` attribute except `src` is supported, so call sites can size/style it like any other image. */
export type StanfordLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>;

/**
 * The Stanford seal, sourced from the single canonical asset
 * ({@link STANFORD_LOGO_ASSET_SRC}). Use this instead of hardcoding
 * `<img src="/stanford.png" />` so every usage shares one source of truth for
 * the asset, and benefits from the bundler's fingerprinting/long-term
 * caching — wrap with `styled(StanfordLogo)` for styled-components sizing,
 * since `className` is forwarded to the underlying `<img>`.
 *
 * @param props.alt - Accessible alt text; defaults to `'Stanford Logo'`.
 */
export function StanfordLogo({
  alt = 'Stanford Logo',
  ...imgProps
}: StanfordLogoProps) {
  return <img src={STANFORD_LOGO_ASSET_SRC} alt={alt} {...imgProps} />;
}
